class PhoneMockupCarousel extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector(".pmc-track");
    this.prevBtn = this.querySelector(".pmc-prev");
    this.nextBtn = this.querySelector(".pmc-next");
    this.activeIndex = 0;
    this.isAnimating = false;

    this.initItems();

    if (this.items.length === 0) return;

    this.total = this.items.length;

    this.prevBtn?.addEventListener("click", () => this.slide("prev"));
    this.nextBtn?.addEventListener("click", () => this.slide("next"));

    this.initTouch();
    this.updateClasses(false);
  }

  initItems() {
    let originalItems = Array.from(this.querySelectorAll(".pmc-item"));
    if (originalItems.length === 0) {
      this.items = [];
      return;
    }

    // If there are less than 3 items, we clone them to make the loop seamless
    if (originalItems.length > 0 && originalItems.length < 3) {
      const cloneCount = Math.ceil(3 / originalItems.length);
      for (let i = 1; i < cloneCount; i++) {
        originalItems.forEach((item) => {
          const clone = item.cloneNode(true);
          // Remove IDs to avoid duplicates if any
          clone.removeAttribute("id");
          this.track.appendChild(clone);
        });
      }
    }

    this.items = Array.from(this.querySelectorAll(".pmc-item"));

    // Update indices
    this.items.forEach((item, index) => {
      item.dataset.index = index;
    });
  }

  slide(direction) {
    if (this.isAnimating) return;
    this.isAnimating = true;
    const previousActiveItem = this.items[this.activeIndex];
    this.items.forEach((item) => item.classList.remove("pmc-item--outgoing"));

    if (direction === "next") {
      this.activeIndex = (this.activeIndex + 1) % this.total;
    } else {
      this.activeIndex = (this.activeIndex - 1 + this.total) % this.total;
    }

    this.updateClasses(true);
    const currentActiveItem = this.items[this.activeIndex];
    const outgoingItem = previousActiveItem && previousActiveItem !== currentActiveItem ? previousActiveItem : null;
    if (outgoingItem) {
      outgoingItem.classList.add("pmc-item--outgoing");
    }

    const computedStyles = window.getComputedStyle(this);
    const durationMs = Number.parseFloat(computedStyles.getPropertyValue("--pmc-slide-duration-ms")) || 260;
    const lockMs = durationMs + 60;

    setTimeout(() => {
      this.isAnimating = false;
      outgoingItem?.classList.remove("pmc-item--outgoing");
    }, lockMs);
  }

  updateClasses(animate) {
    this.items.forEach((item, index) => {
      let targetClass = "";

      const diff = (index - this.activeIndex + this.total) % this.total;

      if (diff === 0) {
        targetClass = "pmc-item--active";
      } else if (diff === 1) {
        targetClass = "pmc-item--right";
      } else if (diff === this.total - 1) {
        targetClass = "pmc-item--left";
      } else {
        targetClass = "pmc-item--hidden";
      }

      if (!animate) {
        item.style.transition = "none";
      } else {
        item.style.transition = "";
      }

      const wasLeft = item.classList.contains("pmc-item--left");
      const wasRight = item.classList.contains("pmc-item--right");

      item.className = `pmc-item ${targetClass}`;

      if (
        animate &&
        ((wasLeft && targetClass === "pmc-item--right") || (wasRight && targetClass === "pmc-item--left"))
      ) {
        item.classList.add("pmc-item--crossing");
      }

      if (!animate) {
        // Force reflow
        void item.offsetWidth;
        setTimeout(() => {
          item.style.transition = "";
        }, 50);
      }
    });
  }

  initTouch() {
    let startX = 0;
    let startY = 0;

    if (!this.track) return;

    this.track.addEventListener(
      "touchstart",
      (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      },
      { passive: true },
    );

    this.track.addEventListener(
      "touchend",
      (e) => {
        const endX = e.changedTouches[0].clientX;
        const endY = e.changedTouches[0].clientY;
        const diffX = endX - startX;
        const diffY = endY - startY;

        // Detect horizontal swipe
        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 40) {
          if (diffX > 0) {
            this.slide("prev");
          } else {
            this.slide("next");
          }
        }
      },
      { passive: true },
    );
  }
}

if (!customElements.get("phone-mockup-carousel")) {
  customElements.define("phone-mockup-carousel", PhoneMockupCarousel);
}
